import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const contains = (intl, messageId) => intl && intl.messages && !!intl.messages[messageId];
const Footer = ({ intl, className }) => {
  const { linkOverrides } = intl.messages;

  const privacyLink = linkOverrides?.find(link => link.key === 'privacy' && link.value !== '')?.value ?? '/links/privacy';
  const cookiesLink = linkOverrides?.find(link => link.key === 'cookies' && link.value !== '')?.value ?? '/links/cookies';
  const termsOfUseLink = linkOverrides?.find(link => link.key === 'termsOfUse' && link.value !== '')?.value ?? '/links/termsOfUse';

  return (<footer className={ `footer ${ className != null ? className : '' }` }>
    <div className="container p-0">
      <div className="row">
        <div className="col">
          <div className="text-center footer-links">
            <ul>
              {contains(intl, 'footer.privacy') && <li><a href={ privacyLink } target="_blank" title={ `${ intl.formatMessage({ id: 'footer.privacy.tooltip' }) }` } rel="noreferrer"><LocalisedMessage id="footer.privacy.title" /></a></li> }
              {contains(intl, 'footer.cookies') && <li><a href={ cookiesLink } target="_blank" title={ intl.formatMessage({ id: 'footer.cookies.tooltip' }) } rel="noreferrer"><LocalisedMessage id="footer.cookies.title" /></a></li> }
              {contains(intl, 'footer.termsOfUse') && <li><a href={ termsOfUseLink } target="_blank" title={ intl.formatMessage({ id: 'footer.termsOfUse.tooltip' }) } rel="noreferrer"><LocalisedMessage id="footer.termsOfUse.title" /></a></li> }
            </ul>
          </div>
          {contains(intl, 'footer.allRightsReserved') && <div id="copyright" className="text-center">&copy;&nbsp;<LocalisedMessage id="footer.allRightsReserved" values={ { Year: (new Date()).getFullYear() } } /></div>}
        </div>
      </div>
    </div>
  </footer>);
};

Footer.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.any,
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  className: PropTypes.string
};

Footer.defaultProps = {
  className: null
};

export default injectIntl(Footer);
